var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('Home-ImagesSlider'),_vm._l((_vm.homeComponents),function(x,idx){return _c(x.comp,_vm._b({key:idx,tag:"component"},'component',x.data,false))})],2)}
var staticRenderFns = []

export { render, staticRenderFns }